/**
 * Base64 of the UTF-8 bytes of a string, which is how Xcipio and the backend encode an id.
 *
 * Unlike a bare window.btoa it does not throw on characters above 0xFF, and it does not
 * need a browser: it falls back to Buffer where there is no btoa.
 */
export default function encodeBase64(value: string): string {
  if (typeof btoa === 'function') {
    const utf8Binary = encodeURIComponent(value)
      .replace(/%([0-9A-F]{2})/g, (_match, hex: string) => String.fromCharCode(parseInt(hex, 16)));

    return btoa(utf8Binary);
  }

  return Buffer.from(value, 'utf8').toString('base64');
}
